<template>
    <div v-if="isFinishLoading">
        <div class="payByMethod" v-if="paymentContent.payMethod=='MOBILE_ALIPAY'||paymentContent.payMethod=='TUI_MOBILE_ALIPAY'" 
            v-html="paymentContent.paymentUrl"></div>
        <div class="page-payment" v-show="isShowAlipayWarning">
            <div><img src="https://resource.rcclchina.com.cn/paySuccess/arrow.png" class="arrow"></div>
            <div class="aliPay_hint">
                <p>点击右上方</p>
                <p>选择用浏览器打开支付</p>
            </div>
        </div>
    </div>
</template>

<script>
import wechatHelper from '@/utilities/wechatHelper'
import api from '@/api'
export default {
    name: "OpenBookingPayByMethod",
    data() {
        return {
            paymentContent: {},
            isShowAlipayWarning: false,
            isFinishLoading: false
        }
    },
    beforeDestroy () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: false, isHideFooter: false})
    },
    async mounted () {
        this.$store.dispatch('HIDE_HEADER_BAR', { isHideHeader: true, isHideFooter: true})
        await this.initPage()
    },
    methods: {
        async initPage() {
            const query = this.$router.currentRoute.query
            if (!query || !query.returnUrl || query.returnUrl == '') {
                return this.$router.go(-1)
            } 
            const orderId = query.orderId
            const payMethod = query.payMethod
            const userToken = this.$store.state.user.userToken
            const isTui = query.isTui && query.isTui == "true"

            let request = {
                orderId: orderId,
                userName: userToken,
                payMethod: payMethod,
                openId: this.$store.state.user.wechatOpenId
            }
            if (isTui) {
                request.openId = this.$store.state.user.tuiWechatOpenId
            }
            const { success, data } = await api.booking.openBookingSubmitPay(request)
            this.$loading.hide()
            if (!success) {
                return location.href = decodeURIComponent(query.returnUrl)
            }
            this.isFinishLoading = true
            if (data.paymentUrl) {
                if (data.needRedirect) {
                    return location.href = data.paymentUrl
                } else {
                    this.paymentContent = data
                    this.$nextTick(()=> {
                        this.processPayMethod()
                    })
                }
            }
        },
        processPayMethod() {
            switch(this.paymentContent.payMethod) {
                case 'TUI_H5_WECHAT_PAY':
                case 'H5_WECHAT_PAY': {
                    this.h5wechatPayHandler()
                    break
                }
                case 'TUI_WECHAT_PAY':
                case 'WECHAT_PAY': {
                    this.wechatPayHandler()
                    break
                }
                case 'TUI_MOBILE_ALIPAY':
                case 'MOBILE_ALIPAY': {
                    this.mobileAlipayFormHandler()
                    break
                }
                default: break
            }
        },
        h5wechatPayHandler() {
            const url = `${this.paymentContent.paymentUrl}&redirect_url=${encodeURIComponent(this.paySuccessUrl)}`
            location.href = url
            //window.location.href = `${this.paymentContent.paymentUrl}&redirect_url=${this.paySuccessUrl}`
        },
        wechatPayHandler () {
            let openId = ''
            if (this.paymentContent.payMethod == 'WECHAT_PAY') {
                openId = this.$store.state.user.wechatOpenId
            } else if (this.paymentContent.payMethod == 'TUI_WECHAT_PAY') {
                openId = this.$store.state.user.tuiWechatOpenId
            }
            
            if (!openId || openId == '') {
                return
            }

            return location.href = `/Rccl.Booking/Booking/OpenBookingPay?paymentId=${this.paymentContent.paymentId}`
            +`&orderId=${this.paymentContent.openBookingOrderId}&openId=${openId}`
            // if (typeof window.WeixinJSBridge == "undefined") {
            //     if (document.addEventListener) {
            //         document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
            //     } else if (document.attachEvent) {
            //         document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady);
            //         document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
            //     }
            // } else {
            //     this.onBridgeReady()
            // }
        },
        mobileAlipayFormHandler () {
            if (wechatHelper.isWeixinBrowser()) {
                this.isShowAlipayWarning = true
                return
            }
            const forms = document.getElementsByTagName('form')
            if (forms) {
                forms[0].submit()
            }
        },
        unionPayHandler () {
            const forms = document.getElementById('pay_form')
            if (forms) {
                forms.action = process.env.VUE_APP_UNION_PAY_URL
                forms.submit()
            }
        },
        onBridgeReady() {
            const wxParam = this.paymentContent.paymentUrl
            const wxrdata = JSON.parse(wxParam)
            const paySuccessUrl = this.paySuccessUrl
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                "appId": wxrdata.appId,     //公众号名称，由商户传入
                "timeStamp": wxrdata.timeStamp,         //时间戳，自1970年以来的秒数
                "nonceStr": wxrdata.nonceStr, //随机串
                "package": wxrdata.package,
                "signType": wxrdata.signType,         //微信签名方式：
                "paySign": wxrdata.paySign //微信签名
                },
                function (res) {
                    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        setTimeout(function () {
                            window.location.href = paySuccessUrl
                        }, 2000)
                    }
                }
            );
        },
    },
    computed: {
        paySuccessUrl() {
            return `${process.env.VUE_APP_BASE_URL}${process.env.VUE_APP_OPBK_PAY_SUCCESS_URL}?paymentId=${this.paymentContent.paymentId}&PromotionCampaign=fixedCoupon&PromotionProduct=3`
        }
    }
}
</script>

<style lang="less" scoped>
.payByMethod {
    display: none;
}

.page-payment {
    top: -10px;
}
</style>
